import {
  type AllDualVariantIconKeys,
  Body,
  Icon,
  type IconProps,
  Stack,
} from "@biom3/react";
import { useIsLessThanMediumScreen } from "@ui-kit/hooks";
import { Fragment, useMemo } from "react";
import { parseTemplate } from "./utils";

export const BadgeContent = ({
  badgeTemplate,
  badgeIcon,
  increase,
  progressPoints,
  iconSx,
}: {
  badgeTemplate: string;
  badgeIcon: AllDualVariantIconKeys;
  increase: string | number;
  progressPoints?: number | string;
  iconSx?: IconProps["sx"];
}) => {
  const isSmallScreenMode = useIsLessThanMediumScreen();

  const placeholderMap = useMemo(
    () => ({
      ...(progressPoints !== undefined
        ? {
            "<progressPoints>": (
              <Body key={`badge-${progressPoints}`} size="small">
                {progressPoints}
              </Body>
            ),
          }
        : {}),
      "<increase>": <Fragment key={`badge-${increase}`}>{increase}</Fragment>,
      "<icon>": (
        <Icon
          key={`badge-${badgeIcon}`}
          variant="bold"
          icon={badgeIcon}
          sx={iconSx}
        />
      ),
    }),
    [progressPoints, increase, badgeIcon, iconSx],
  );

  return isSmallScreenMode ? (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      gap="base.spacing.x1"
    >
      <Body key={`badge-${increase}`} size={"small"}>
        +{increase}
      </Body>
      <Icon
        key={`badge-${badgeIcon}`}
        variant="bold"
        icon={badgeIcon}
        sx={iconSx}
      />
    </Stack>
  ) : (
    <Body
      size="small"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "base.spacing.x1",
      }}
    >
      {parseTemplate(badgeTemplate, placeholderMap)}
    </Body>
  );
};
